import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('management-reports-commissions', storeModule.createStoreModule('management-reports-commissions'))
